export default [
  {
    path: '/sarai/list',
    name: 'sarai-list',
    component: () => import('@/views/sarai/index.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Sarai List',
      breadcrumb: [
        { title: 'Dashboard', url: '/' },
        { title: 'Sarai' },
        { title: 'Sarai List', active: true }
      ],
      permissions: ['sarai_list']
    }
  },
  {
    path: '/sarai/add',
    name: 'create-sarai',
    component: () => import('@/views/sarai/action.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Add Sarai',
      parent: 'SaraiList',
      breadcrumb: [
        { title: 'Dashboard', url: '/' },
        { title: 'Sarai', url: '/sarai/list' },
        { title: 'Add Sarai', active: true }
      ],
      permissions: ['sarai_create']
    }
  },
  {
    path: '/sarai/:id/edit',
    name: 'edit-sarai',
    component: () => import('@/views/sarai/action.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Edit Sarai',
      parent: 'SaraiList',
      breadcrumb: [
        { title: 'Dashboard', url: '/' },
        { title: 'Sarai', url: '/sarai/list' },
        { title: 'Edit Sarai', active: true }
      ],
      permissions: ['sarai_edit', 'sarai_view']
    }
  }
]

